"use client";
import { useSelector } from "react-redux";
import { useFindDoctorsAccessQuery } from "@/Redux/apis/auth";

export default function useFindDoctorsAccess() {
  const user = useSelector(state => state?.userData?.userData?.user);
  // Account ID keys the RTK cache, so switching accounts cannot reuse a grant.
  const query = useFindDoctorsAccessQuery(user?._id, {
    skip: !user?._id || user.type !== "reps",
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    pollingInterval: 30000,
    skipPollingIfUnfocused: true,
  });
  return {
    enabled: !query.isError && query.currentData?.data?.enabled === true,
    checking: !user?._id || query.isLoading || query.isUninitialized,
    error: query.error,
    retry: query.refetch,
  };
}
